import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const Search = ({packages}) => {
  const text = config.registrationForm.package.search
  return <tr>
    <td><strong>{text[0]}</strong> {text[1]}</td>
    {
      packages.map(item => <td key={item.id}>{<i className={`ico-${item.search ? `ima` : `nema`} ico`} />}</td>)
    }
  </tr>
}
Search.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    search: PropTypes.bool
  })).isRequired
}

Search.defaultProps = {
  packages: []
}
